import { ApiResource } from '@/core/models/ApiResource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ContractTemplate } from './contract-template.interface';
import { ContractTemplateService } from './contract-template.service';

const service = new ContractTemplateService();

export interface ContractTemplateState {
   contractTemplatesOverview?: ApiResource<Array<ContractTemplate>>;
}

const ContractTemplateStore: Module<ContractTemplateState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_CONTRACT_TEMPLATES_OVERVIEW(state, overview?: ApiResource<Array<ContractTemplate>>) {
         state.contractTemplatesOverview = overview;
      },
      ADD_CONTRACT_TEMPLATE(state, contractTemplate: ContractTemplate) {
         state.contractTemplatesOverview?.data.push(contractTemplate);
         state.contractTemplatesOverview!.meta.total++;
      },
      CHANGE_CONTRACT_TEMPLATE(state, contractTemplate: ContractTemplate) {
         const index = (state.contractTemplatesOverview?.data || []).findIndex((ct) => ct.id === contractTemplate.id);
         if (index > -1) state.contractTemplatesOverview?.data.splice(index, 1, contractTemplate);
      },
      DELETE_CONTRACT_TEMPLATE(state, contractTemplateId: number) {
         const index = (state.contractTemplatesOverview?.data || []).findIndex((ct) => ct.id === contractTemplateId);
         if (index > -1) state.contractTemplatesOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getContractTemplates(context, payload: { customerId: number; query: LocationQuery }) {
         const response = await service.getContractTemplates(payload.customerId, payload.query);
         context.commit('SET_CONTRACT_TEMPLATES_OVERVIEW', response);
         return response;
      },
      async getContractTemplate(context, payload: { customerId: number; contractTemplateId: number }) {
         await service.getContractTemplate(payload.customerId, payload.contractTemplateId);
      },
      async createContractTemplate(context, payload: { customerId: number; contractTemplate: ContractTemplate }) {
         const response = await service.postContractTemplate(payload.customerId, payload.contractTemplate);
         context.commit('ADD_CONTRACT_TEMPLATE', response);
         return response;
      },
      async changeContractTemplate(
         context,
         payload: { customerId: number; contractTemplateId: number; contractTemplate: ContractTemplate },
      ) {
         const { customerId, contractTemplateId, contractTemplate } = payload;
         const response = await service.putContractTemplate(customerId, contractTemplateId, contractTemplate);
         context.commit('CHANGE_CONTRACT_TEMPLATE', response);
         return response;
      },
      async deleteContractTemplate(context, payload: { customerId: number; contractTemplateId: number }) {
         const response = await service.deleteContractTemplate(payload.customerId, payload.contractTemplateId);
         context.commit('DELETE_CONTRACT_TEMPLATE', payload.contractTemplateId);
         return response;
      },
      async calculateField(context, payload: { customerId: number; contractTemplateId: number; employment: any }) {
         return service.calculateField(payload.customerId, payload.contractTemplateId, payload.employment);
      },
   },
};

export default ContractTemplateStore;
